import React, { ChangeEvent, useEffect, useRef, useState, useImperativeHandle } from "react";
import { Link, useParams } from "react-router-dom";
import CommonDropdownMenuThree from "../Shared/CommonDropdownMenuThree";
import CommonDropdownMenufour from "../Shared/CommonDropdownMenufour";
import "./CreateInvoice.css";
import UnitOption from "./UnitOption";
import apiClient from '../../services/apiClient';

const CreateInvoiceContent = React.forwardRef((props, ref) => {
  const options = ["Custom Date", 'Smart date'];
  const options_sub = ["Payment is due on a fixed calendar date", 'Payment due date is based on event or invoice date'];
  const options2 = ["day(s)", "Week(s)", "month(s)"];
  const options3 = ["before event date", "after event date"];

  const { invoiceId } = useParams();

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const { eventID } = useParams();
  const [EventData, setEventData] = useState({});

  // State variables
  const [services, setServices] = useState([]);
  const [showDueDateBox, setShowDueDateBox] = useState(null);
  const [isSelectItemBoxOpen, setIsSelectItemBoxOpen] = useState(false);
  const selectItemBoxRef = useRef(null);
  const [showTaxBox, setShowTaxBox] = useState(false);
  const [showDiscountBox, setShowDiscountBox] = useState(false);
  const [subtotalprice, setsubtotalprice] = useState(0);
  const [totalprice, settotalprice] = useState(0);
  const [tax, settax] = useState(0);
  const [taxval, settaxval] = useState(0);
  const [taxper, settaxper] = useState(false);
  const [discount, setdiscount] = useState(0);
  const [discountval, setdiscountval] = useState(0);
  const [discountper, setdiscountper] = useState(false);

  const [pakagesdetails, setpakagesdetails] = useState([]);

  const [itemdetails, setitemdetails] = useState([]);

  const [smartdate, setsmartdate] = useState(false);
  const [smartday, setsmartday] = useState("");
  const [smartmonth, setsmartmonth] = useState(false);
  const [smartyear, setsmartyear] = useState(false);


  const [partialfriction, setpartialfriction] = useState(10);

  const [companylogo, setCompanylogo] = useState();
  const [secondarylogo, setSecondarylogo] = useState();
  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setcompanyname] = useState();










  const [custompaymentbox, setcustompaymentbox] = useState(null);
  const [showcustombox, setshowcustombox] = useState(false);
  const [customprice, setcustomprice] = useState(0);
  const [amounttype, setamounttype] = useState(false);

  const [payments, setPayments] = useState([
    {
      amount: 0, // Will be recalculated when services load
      dueDate: new Date().toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      }),
      paymentId: "",
      type: '',
      smartdays: '',
      smartdirection: '',
      paymenttype: 'equal',
    },
  ]);

  const ref2 = useRef([]);
  const paymentsLoadedFromServerRef = useRef(false);

  const handleInput = (e, index) => {
    if (ref2.current[index]) {
      ref2.current[index].style.height = "auto";
      ref2.current[index].style.height = `${ref2.current[index].scrollHeight + 16}px`;
    }
  };



  useEffect(() => {

    // useLayoutEffect TO AVOID FLICKERING
    ref2.current.map((tab, index) => {
      if (ref2.current[index]) {
        ref2.current[index].style.height = "auto";
        ref2.current[index].style.height = `${ref2.current[index].scrollHeight + 16}px`;
      }
    });

    // NEEDS TO ADD 2. I THINK IT'S BECAUSE OF THE BORDER
  }, [services]);


  useEffect(() => {

    if (!invoiceId) {
      setServices([...services, {
        showServiceInfo: false,
        qty: 0,
        unit_option: "Item",
        tax: false,
        price: 0,
        itemtotalprice: 0,
        type: "",
        descp: "",
      },]);
    }

  }, []);


  useEffect(() => {
    setsubtotalprice(10);

  }, []);
  /*
    useEffect(() => {
                        if(props.items){
                                          props.items.forEach((tabs1, index) => {
                                                                        setServices([
                                                                          ...services,
                                                                          {
                                                                            showServiceInfo: false,
                                                                            qty:tabs1.qty,
                                                                            unit:"",
                                                                            tax:false,
                                                                            price:tabs1.price,
                                                                            itemtotalprice:0,
                                                                            type:"",
                                                                            desc:"",
                                                                          },
                                                                        ])
                                                    });
                        }
  
                        if(props.invoicepayments){
                          
                          props.invoicepayments.forEach((tabs1, index) => {
                                                        setPayments([
                                                          ...payments,
                                                          {
                                                            amount:10,
                                                            dueDate:tabs1.dueDate,
                                                            paymentId:tabs1.paymentId,
                                                          },
                                                        ])
                                    });
                         }
  
                        
    }, [props.items,props.invoicepayments]);
  
    */

  useImperativeHandle(ref, () => ({
    getMyservices: () => {
      return services
    },
    getTotalpayment: () => {
      return totalprice
    },
    getPayments: () => {
      return payments
    },
    getTaxper: () => {
      return taxper
    },
    getTax: () => {
      return tax
    },
    getDiscountper: () => {
      return discountper
    },
    getDiscount: () => {
      return discount
    },
  }), [services, totalprice, payments, taxper, tax, discountper, discount]);


  // const [selectedDueDate, setSelectedDueDate] = useState("");

  // Current date setup
  const currentDate = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const formattedDate = `${months[currentDate.getMonth()]
    } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

  // Functions to handle toggling of various components
  const toggleHandleServiceInfo = (index) => {
    const updatedServices = [...services];
    updatedServices[index].showServiceInfo =
      !updatedServices[index].showServiceInfo;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  };
  // Handle add new service
  const addNewService = () => {
    setServices([
      ...services,
      {
        showServiceInfo: false,
        qty: 1,
        unit_option: "Item",
        tax: false,
        price: 0,
        itemtotalprice: 0,
        type: "",
        descp: "",
      },
    ]); // Add a new empty service object
  };



  // Distribute `total` equally across `count` rows.
  // The last row gets the remainder so the amounts always sum exactly to `total`.
  const distributeEqual = (total, count) => {
    if (count <= 0) return [];
    const per = Math.round((total / count) * 100) / 100;
    const amounts = Array(count).fill(per);
    const sumOfFirst = Math.round(per * (count - 1) * 100) / 100;
    amounts[count - 1] = Math.round((total - sumOfFirst) * 100) / 100;
    return amounts;
  };

  // Handle add new payment schedule – new row is "equal", then recalculate all amounts
  const addNewPayment = () => {
    const dueDateToday = new Date().toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
    const newPayment = {
      amount: 0,
      dueDate: dueDateToday,
      paymentId: "",
      type: '',
      smartdays: '',
      smartdirection: '',
      paymenttype: 'equal',
    };
    const updatedPayments = [...payments.map((p) => ({ ...p })), { ...newPayment }];
    const total = Number(totalprice) || 0;
    const customSum = updatedPayments
      .filter((p) => p.paymenttype === 'custom')
      .reduce((sum, p) => sum + Number(p.amount || 0), 0);
    const equalRows = updatedPayments.filter((p) => p.paymenttype === 'equal');
    const remainingForEqual = total - customSum;
    if (equalRows.length > 0) {
      const amounts = distributeEqual(remainingForEqual, equalRows.length);
      let eqIdx = 0;
      updatedPayments.forEach((p) => {
        if (p.paymenttype === 'equal') p.amount = amounts[eqIdx++];
      });
    }
    setPayments(updatedPayments);
  };

  // Payment amounts are now updated in the services calculation useEffect (line ~693)
  // to avoid duplicate updates and stale closure issues

  // Functions to handle toggling of various components
  const toggleTaxBox = () => {
    setShowTaxBox(!showTaxBox);
    setShowDiscountBox(false);
  };
  // Functions to handle toggling of various components
  const toggleDiscountBox = () => {
    setShowDiscountBox(!showDiscountBox);
    setShowTaxBox(false);
  };
  // handle delete service
  const deleteService = (index) => {
    const updatedServices = [...services];
    updatedServices.splice(index, 1);
    setServices(updatedServices);
  };
  // handle delete payment – recalculate equal rows from scratch, or add to first custom row
  const deletePayment = (index) => {
    if (payments.length <= 1) {
      return;
    }
    const updatedPayments = payments.filter((_, i) => i !== index).map((p) => ({ ...p }));
    const equalRows = updatedPayments.filter((p) => p.paymenttype === 'equal');
    if (equalRows.length > 0) {
      const customSum = updatedPayments
        .filter((p) => p.paymenttype === 'custom')
        .reduce((sum, p) => sum + Number(p.amount || 0), 0);
      const remainingForEqual = Number(totalprice) - customSum;
      const amounts = distributeEqual(remainingForEqual, equalRows.length);
      let eqIdx = 0;
      updatedPayments.forEach((p) => {
        if (p.paymenttype === 'equal') p.amount = amounts[eqIdx++];
      });
    } else {
      const deletedAmount = Number(payments[index].amount) || 0;
      const firstCustomIndex = updatedPayments.findIndex((p) => p.paymenttype === 'custom');
      if (firstCustomIndex !== -1) {
        const current = Number(updatedPayments[firstCustomIndex].amount) || 0;
        updatedPayments[firstCustomIndex].amount = Math.round((current + deletedAmount) * 100) / 100;
      }
    }
    setPayments(updatedPayments);
  };
  const handlePropagation = (e) => {
    e.stopPropagation();
  };

  const togglecustompaymentBox = (index, currentAmount) => {
    if (payments.length === 1) return;
    setcustompaymentbox((prevIndex) => (prevIndex !== index ? index : null));
    if (currentAmount != null && currentAmount !== undefined) setcustomprice(currentAmount);
  };

  const savepaymenttogle = (index) => {
    if (payments.length === 1) {
      setcustompaymentbox(null);
      setcustomprice(0);
      setshowcustombox(false);
      return;
    }
    // Helper: recalculate all equal rows from scratch using distributeEqual
    const recalcEqualRows = (paymentsList) => {
      const customSum = paymentsList
        .filter(p => p.paymenttype === 'custom')
        .reduce((sum, p) => sum + Number(p.amount || 0), 0);
      const equalRows = paymentsList.filter(p => p.paymenttype === 'equal');
      if (equalRows.length > 0) {
        const remaining = Number(totalprice) - customSum;
        const amounts = distributeEqual(remaining, equalRows.length);
        let eqIdx = 0;
        return paymentsList.map(p =>
          p.paymenttype === 'equal' ? { ...p, amount: amounts[eqIdx++] } : { ...p }
        );
      }
      return paymentsList.map(p => ({ ...p }));
    };

    if (amounttype) {
      const updatedPayments = [...payments];
      updatedPayments[index].paymenttype = 'equal';
      const result = recalcEqualRows(updatedPayments);
      setPayments(result);
      setcustompaymentbox(null);
      setcustomprice(0);
      setshowcustombox(false);
      setamounttype(false);
    } else {
      const EqualPaymentsCount = payments.filter((p) => p.paymenttype === 'equal').length;
      const updatedPayments = [...payments];
      if (EqualPaymentsCount === 0) {
        // All rows are custom: set this row to customprice, distribute difference proportionally to others
        updatedPayments[index].amount = Number(customprice);
        const otherIndices = updatedPayments.map((_, i) => i).filter((i) => i !== index);
        const totalOther = otherIndices.reduce((sum, i) => sum + Number(updatedPayments[i].amount || 0), 0);
        const targetOtherSum = Number(totalprice) - Number(customprice);
        if (totalOther > 0 && otherIndices.length > 0) {
          let runningSum = 0;
          otherIndices.forEach((i, idx) => {
            if (idx === otherIndices.length - 1) {
              updatedPayments[i].amount = Math.round((targetOtherSum - runningSum) * 100) / 100;
            } else {
              const share = Math.round((Number(updatedPayments[i].amount) / totalOther * targetOtherSum) * 100) / 100;
              runningSum += share;
              updatedPayments[i].amount = share;
            }
          });
        }
        setPayments(updatedPayments);
        setcustompaymentbox(null);
        setcustomprice(0);
        setshowcustombox(false);
      } else if (EqualPaymentsCount !== 1) {
        updatedPayments[index].amount = customprice;
        updatedPayments[index].paymenttype = 'custom';
        const result = recalcEqualRows(updatedPayments);
        setPayments(result);
        setcustompaymentbox(null);
        setcustomprice(0);
        setshowcustombox(false);
      } else if ((EqualPaymentsCount === 1) && (updatedPayments[index].paymenttype === 'custom')) {
        updatedPayments[index].amount = customprice;
        const result = recalcEqualRows(updatedPayments);
        setPayments(result);
        setcustompaymentbox(null);
        setcustomprice(0);
        setshowcustombox(false);
      } else if ((EqualPaymentsCount === 1) && (updatedPayments[index].paymenttype === 'equal')) {
        updatedPayments[index].amount = customprice;
        updatedPayments[index].paymenttype = 'custom';
        const result = recalcEqualRows(updatedPayments);
        setPayments(result);
        setcustompaymentbox(null);
        setcustomprice(0);
        setshowcustombox(false);
      }
    }
  };

  const toggleDueDateBox = (index) => {
    if (smartdate) {


      // const result = new Date(EventData.date);

      const result = new Date(EventData.date);
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


      let options = {
        timeZone: timeZone,  // Specify your timezone
        year: 'numeric',
        month: 'long',
        day: 'numeric',

      };

      result.toLocaleString();
      if (smartyear === 'before event date') {

        if (smartmonth === 'day(s)') {


          result.setDate(result.getDate() - Number(smartday));

        } else if (smartmonth === 'Week(s)') {
          result.setDate(result.getDate() - (Number(smartday) * 7));

        } else if (smartmonth === 'month(s)') {

          result.setMonth(result.getMonth() - Number(smartday));

        }

      } else if (smartyear === 'after event date') {
        if (smartmonth == 'day(s)') {


          result.setDate(result.getDate() + Number(smartday));

        } else if (smartmonth == 'Week(s)') {
          result.setDate(result.getDate() + (Number(smartday) * 7));

        } else if (smartmonth == 'month(s)') {

          result.setMonth(result.getMonth() + Number(smartday));

        }
      } else if (smartyear === 'after invoice has been sent') {
        result.setDate(result.getDate());
      }
      //const formattedDate = formatDateToMMDDYYYY(result);

      //const formattedDate = result.toLocaleDateString(); 

      const formattedDate = result.toLocaleString("en-US", options);

      const updatedPayments = [...payments];
      updatedPayments[index].dueDate = formattedDate;
      updatedPayments[index].type = 'smartdate';
      updatedPayments[index].smartdays = String(smartday);
      updatedPayments[index].timetype = smartmonth;
      updatedPayments[index].smartdirection = smartyear;
      setPayments(updatedPayments);
      //setsmartdate(true);

    }
    setShowDueDateBox((prevIndex) => (prevIndex !== index ? index : null));
  };




  const handleDateChange = (event, index) => {
    let currentDate = new Date();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let options = {
      timeZone: timeZone,  // Specify your timezone
      year: 'numeric',
      month: 'long',
      day: 'numeric',

    };
    const inputDate = event.target.value + 'T00:00:00';
    const newDueDate = new Date(inputDate);




    /*
        const dt = new Date();
        let diffTZ = dt.getTimezoneOffset();
    
        const localTime = newDueDate.getTime();
    const localOffset = newDueDate.getTimezoneOffset() * 60000;
    const utc = localTime + localOffset;
    const offset =  diffTZ; // UTC of USA Eastern Time Zone is -05.00
    const usa = utc + (3600000 * offset);
     const newDueDate1 = new Date(usa);
    
    */

    ///newDueDate=usaTimeNow;


    if (isNaN(newDueDate)) {
      console.error("Invalid date:", inputDate);
      return;
    }

    const formattedDueDate = newDueDate.toLocaleString("en-US", options);


    const updatedPayments = [...payments];


    var y = currentDate.getFullYear();
    var m = currentDate.getMonth();
    var d = currentDate.getDate();

    var y2 = newDueDate.getFullYear();
    var m2 = newDueDate.getMonth();
    var d2 = newDueDate.getDate();

    var comparedate1 = new Date(y, m, d);
    var comparedate2 = new Date(y2, m2, d2);




    if (comparedate2 > comparedate1) {
      // upcoming date
    } else if (comparedate2 < comparedate1) {
      // overdue date
    } else {
      // due today
    }
    updatedPayments[index].dueDate = formattedDueDate;
    updatedPayments[index].type = '';
    updatedPayments[index].smartdays = '';
    updatedPayments[index].timetype = '';
    updatedPayments[index].smartdirection = '';
    setPayments(updatedPayments);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        selectItemBoxRef.current &&
        !selectItemBoxRef.current.contains(event.target)
      ) {
        setIsSelectItemBoxOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectItemBoxRef]);


  const changeqty = (e, index) => {
    // alert(e.target.value);
    const updatedServices = [...services];
    updatedServices[index].qty = e.target.value;
    updatedServices[index].itemtotalprice = updatedServices[index].price * e.target.value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  }

  const pakageset = (e, index, packagedetail) => {
    // alert(parseInt(packagedetail.quantity));
    const updatedServices = [...services];
    updatedServices[index].qty = 1;
    updatedServices[index].price = parseFloat(packagedetail.price);
    updatedServices[index].type = packagedetail.name;
    updatedServices[index].descp = packagedetail.description;
    updatedServices[index].unit_option = packagedetail.unit_option;
    updatedServices[index].itemtotalprice = parseFloat(packagedetail.price);
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
    toggleHandleServiceInfo(index);
    handleInput(e);
  }



  const handleSelectedValueChange = (value, indexval) => {
    // setSelectedValue(value);
    //alert(indexval);
    const updatedServices = [...services];
    updatedServices[indexval].unit_option = value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  };

  const handleOptionSelectsmartmonth = (value) => {
    setsmartmonth(value);
  }

  const handleOptionSelectsmartyear = (value) => {
    setsmartyear(value);
  }

  const handleOptionSelect = (value) => {

    // alert(value);

    if (value == 'Smart date') {
      // alert('dhirendra');
      setsmartdate(true);
    } else {
      setsmartdate(false);
    }
  }

  const changeprice = (e, index) => {
    // alert(e.target.value);
    const updatedServices = [...services];
    updatedServices[index].price = e.target.value;
    updatedServices[index].itemtotalprice = updatedServices[index].qty * e.target.value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  }


  const changetype = (e, index) => {
    // alert(e.target.value);
    const updatedServices = [...services];
    updatedServices[index].type = e.target.value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  }


  const changedesc = (e, index) => {
    // alert(e.target.value);
    const updatedServices = [...services];
    updatedServices[index].descp = e.target.value;
    setServices(updatedServices);
    setIsSelectItemBoxOpen(!isSelectItemBoxOpen);
  }








  useEffect(() => {
    const fetchpakages = async () => {
      try {
        const response = await apiClient.get(`/packages`);
        response.data.forEach((tabs1, index) => {

          const pakagesdetail = {
            id: tabs1.id,
            name: tabs1.name,
            price: tabs1.price,
            description: tabs1.description,
            quantity: tabs1.quantity,
            tax: tabs1.tax,
            unit_option: tabs1.unit_option,
          };
          setpakagesdetails(pakagesdetails => [...pakagesdetails, pakagesdetail]);

          // Use functional update for setTabs to ensure latest state
        });

      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };

    const fetchproducts = async () => {
      try {
        const productresponse = await apiClient.get(`/products`);
        productresponse.data.forEach((tabs1, index) => {

          const itemdetail = {
            id: tabs1.id,
            name: tabs1.name,
            price: tabs1.price,
            description: tabs1.description,
            quantity: tabs1.quantity,
            tax: tabs1.tax,
            unit_option: tabs1.unit_option,
          };
          setitemdetails(itemdetails => [...itemdetails, itemdetail]);

          // Use functional update for setTabs to ensure latest state
        });

      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchpakages();
    fetchproducts();

    const fetchContract = async () => {
      try {
        const response = await apiClient.get(`/invoice/${invoiceId}`);
        setServices(response.data.invoice_item);
        const normalized = (response.data.invoice_payment || []).map((p) => ({
          ...p,
          paymenttype: p.paymenttype ?? 'equal',
        }));
        setPayments(normalized);
        paymentsLoadedFromServerRef.current = true;
        if (response.data.taxper != 0) {
          settaxper(true);
          settax(response.data.tax);
        } else {
          settaxper(false);
          settax(response.data.tax);
        }
        if (response.data.discountper != 0) {
          setdiscountper(true);
          setdiscount(response.data.discount);
        } else {
          setdiscountper(false);
          setdiscount(response.data.discount);
        }
      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchContract();


    const fetchuserdata = async () => {
      try {
        const response = await apiClient.get(`/userdetaila/${JSON.parse(localStorage.getItem('user')).user.id}`);

        const userDetails = response.data.usersdetails?.[0];
        if (userDetails) {
          setCompanylogo(userDetails.Main_Logo ? process.env.REACT_APP_BACKEND_URL + userDetails.Main_Logo : null);
          setSecondarylogo(userDetails.Secondary_Logo ? process.env.REACT_APP_BACKEND_URL + userDetails.Secondary_Logo : null);
          setPhone(userDetails.Phone_Number);
          setCompanyemail(userDetails.Company_Email);
          setFname(userDetails.first_name);
          setLname(userDetails.last_name);
          setcompanyname(userDetails.companyname);
        }

      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchuserdata();


    const fetchEventDetails = async () => {
      try {
        const response = await apiClient.get(`/event/${eventID}`);
        if (response.data.success === true) {
          setEventData(response.data.events);
          // setCompanyemail(response.data.usersdetails[0].email);
        }
      } catch (error) {
        console.error('Error fetching event details:', error);
      }
    };

    fetchEventDetails();


  }, []);


  useEffect(() => {
    // Calculate subtotal from services
    let sum = services.reduce(function (prev, current) {
      return prev + (parseFloat(current.itemtotalprice) || 0);
    }, 0);

    setsubtotalprice(Math.round(sum * 100) / 100);

    // Calculate total price with tax and discount
    let calculatedTotal = sum;
    let taxValue = 0;
    let discountValue = 0;

    if (taxper) {
      taxValue = Math.round((tax * sum / 100) * 100) / 100;
      calculatedTotal = sum + taxValue;
    } else {
      taxValue = Math.round((parseFloat(tax) || 0) * 100) / 100;
      calculatedTotal = sum + taxValue;
    }
    settaxval(taxValue);

    if (discountper) {
      discountValue = Math.round((discount * sum / 100) * 100) / 100;
      calculatedTotal = calculatedTotal - discountValue;
    } else {
      discountValue = Math.round((parseFloat(discount) || 0) * 100) / 100;
      calculatedTotal = calculatedTotal - discountValue;
    }
    setdiscountval(discountValue);

    // Ensure we have a valid number
    calculatedTotal = isNaN(calculatedTotal) ? 0 : Math.round(calculatedTotal * 100) / 100;
    settotalprice(calculatedTotal);

    // Update equal-type payment amounts based on calculated total (preserve custom amounts)
    if (!paymentsLoadedFromServerRef.current) {
      if (payments.length && calculatedTotal > 0) {
        const customSum = payments
          .filter((p) => p.paymenttype === 'custom')
          .reduce((sum, p) => sum + Number(p.amount || 0), 0);
        const equalRows = payments.filter((p) => p.paymenttype === 'equal');
        if (equalRows.length > 0) {
          const remainingForEqual = calculatedTotal - customSum;
          const amounts = distributeEqual(remainingForEqual, equalRows.length);
          let eqIdx = 0;
          const newpayments = payments.map((p) => {
            if (p.paymenttype === 'equal') return { ...p, amount: amounts[eqIdx++] };
            return { ...p };
          });
          setPayments(newpayments);
        }
      }
    }

    // alert(sum);
  }, [services, tax, discount, discountper, taxper]);

  // Separate useEffect to notify parent AFTER payments state has updated
  useEffect(() => {
    if (props.functioncall) {
      props.functioncall();
    }
  }, [payments]);

  if (props.invoiceorder) {
    props.invoiceorder();  // This should call handletax from the parent
  }
  function formatDateToMMDDYYYY(date) {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with leading zero if needed
    const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
    const year = d.getFullYear(); // Get the year

    return `${month}/${day}/${year}`;
  }

  const [isProcessed, setIsProcessed] = useState(false);

  useEffect(() => {
    if (payments.length > 0 && !isProcessed && EventData && EventData.date) {
      const [year, month, day] = EventData.date.split("-").map(Number);

      payments.forEach((ptab, pindex) => {
        if (ptab.type === 'smartdate') {
          const result = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));

          const timeType = (ptab.timetype || '').toLowerCase();
          // Get direction from smartdirection, dueDate text, or paymentId (backward compat for old data)
          const direction = ptab.smartdirection || ptab.dueDate || ptab.paymentId || '';
          const isBefore = direction.includes('before');
          const isAfter = direction.includes('after event date') || direction.includes('after invoice');

          if (isBefore) {
            if (timeType === 'day(s)') {
              result.setUTCDate(result.getUTCDate() - Number(ptab.smartdays));
            } else if (timeType === 'week(s)') {
              result.setUTCDate(result.getUTCDate() - (Number(ptab.smartdays) * 7));
            } else if (timeType === 'month(s)') {
              result.setUTCMonth(result.getUTCMonth() - Number(ptab.smartdays));
            }
          } else if (isAfter) {
            if (timeType === 'day(s)') {
              result.setUTCDate(result.getUTCDate() + Number(ptab.smartdays));
            } else if (timeType === 'week(s)') {
              result.setUTCDate(result.getUTCDate() + (Number(ptab.smartdays) * 7));
            } else if (timeType === 'month(s)') {
              result.setUTCMonth(result.getUTCMonth() + Number(ptab.smartdays));
            }
          }

          const isoDate = result.toISOString();

          const userLocalDate = new Date(isoDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          });

          setPayments(prevTabs => {
            return prevTabs.map((tab, index) => {
              if (index === pindex) {
                return {
                  ...tab,
                  dueDate: userLocalDate,
                };
              }
              return tab;
            });
          });

          setIsProcessed(true);
        }
      });
    }
  }, [payments, isProcessed, EventData]);



  return (
    <>
      {" "}
      <section className='section_container'>
        {/* Customer Details here */}
        <div className='customer_details'>
          {/* Customer info */}


          {companylogo ? (
            <>
              <div className='logo text-center'>
                <h4>
                  <img src={secondarylogo} alt='Main Logo Preview' className='mainimgpath img-fluid' />
                </h4>
              </div>
            </>
          ) : (<>

          </>)}



          <div className='title'>
            <h4>{companyname}</h4>
          </div>
          <div className='item'>
            <span style={{ textTransform: "capitalize" }}>{fname} {lname} </span>
            <span> {phone} </span>
            <span> {companyemail}</span>

          </div>
        </div>

        {/* Invoice content */}
        <div className='invoice'>
          <h3 style={{ margin: "0px 40px" }}>Invoice</h3>

          {/* invoice table */}
          <div className='invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4'>
            <div
              className='table_item invoice_td position-relative'
              type='button'>
              <span className=" hover_effect">Bill to</span><br />
              <span>{EventData.cl_firstname} {EventData.cl_lastname}</span>




            </div>
            <div
              className='table_item  invoice_td position-relative'
              type='button' style={{ marginRight: '4%' }}>
              <span className="hover_effect">invoice #</span>

              <br />
              <span>{props.invoicenumber}</span>




            </div>

            <div className='table_item  purchase_td position-relative'>
              <span className="hover_effect">Purchase order #</span>
              <br />
              <span><input className="purchageorder" style={{ backgroundColor: '#e8eff7' }} type="text" defaultValue={props.purchageorder} onChange={(e) => props.invoiceorder(e.target.value)} /></span>

            </div>
          </div>

          <div className='invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4'>
            <div></div>
            <div className='table_item table_item_date_issued position-relative'>
              <span>Date Issued</span> <br />
              <div
                className='date position-absolute'
                style={{ fontSize: "14px" }}>
                {formattedDate}
              </div>
            </div>
            <div className='table_item position-relative'>
              <span>Next Payment Due</span>
              <br />
              <div
                className='date position-absolute'
                style={{ fontSize: "14px" }}>
                {payments.length ? payments[0].dueDate : ''}
              </div>
            </div>
          </div>

          {/* service area */}
          <div className='service_area d-flex align-items-center justify-content-between py-3'>
            <div className='service_item'>
              <div className='service_info_top'>
                <span>SERVICE INFO</span>
              </div>
            </div>
            <div className='service_item d-flex align-items-center'>
              <span className='me-5'>QTY</span>
              <span>UNIT</span>
            </div>
            <div className='service_item'>
              <span className='me-3'> { /*TAX*/}&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; </span>
              <span>PRICE</span>
            </div>
          </div>

          {/* create new service */}
          {/* Render dynamic services */}
          {services.map((service, index) => (
            <div
              key={index}
              className='create_new_service flex-wrap d-flex align-items-center justify-content-between py-3 position-relative'>
              <div className='service_item position-relative'>
                <div className='service_info_box' style={{ marginTop: "41px" }}>
                  <div
                    className='service_info'
                    onClick={() => toggleHandleServiceInfo(index)}>
                    <span className="pricespan2">*</span>
                    <input type='text' id={`name-${index}`} placeholder='Type or Select a Service' value={service.type} onChange={(e) => changetype(e, index)} />
                    <small></small>
                  </div>
                  <div className='desc mt-2'> &nbsp;
                    {/* <textarea name="" className="textare" placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)}></textarea> */}
                    {/* <input type='text' placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)} /> */}
                  </div>
                </div>


                {/* Select item */}
                {service?.showServiceInfo && (
                  <div className='select_item_box' ref={selectItemBoxRef}>
                    {/* nav item */}
                    <ul
                      className='nav nav-pills justify-content-between mb-3'
                      id='pills-tab'
                      role='tablist'>
                      <li className='nav-item' role='presentation'>
                        <button
                          className='nav-link active'
                          id='pills-home-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-home'
                          type='button'
                          role='tab'
                          aria-controls='pills-home'
                          aria-selected='true'>
                          All
                        </button>
                      </li>
                      <li className='nav-item' role='presentation'>
                        <button
                          className='nav-link'
                          id='pills-profile-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-profile'
                          type='button'
                          role='tab'
                          aria-controls='pills-profile'
                          aria-selected='false'>
                          Package
                        </button>
                      </li>
                      <li className='nav-item' role='presentation'>
                        <button
                          className='nav-link'
                          id='pills-contact-tab'
                          data-bs-toggle='pill'
                          data-bs-target='#pills-contact'
                          type='button'
                          role='tab'
                          aria-controls='pills-contact'
                          aria-selected='false'>
                          Items
                        </button>
                      </li>
                    </ul>

                    {/* Tab content */}
                    <div className='tab-content' id='pills-tabContent'>
                      <div
                        className='tab-pane fade show active'
                        id='pills-home'
                        role='tabpanel'
                        aria-labelledby='pills-home-tab'
                        tabIndex='0'>
                        <div className='tab_box_item px-3 py-3'>
                          <div className='row'>
                            {/* single item */}

                            {pakagesdetails.map((pakagesdetail, index2) => (
                              <div className='col-md-12 pointer' onClick={(e) => pakageset(e, index, pakagesdetail)} >
                                <div className='d-flex justify-content-between mt-3'>
                                  <div className='single_item'>
                                    <h5>
                                      {pakagesdetail.name}
                                    </h5>

                                    <div className='d-flex align-items-center mt-2 cart_item'>
                                      {/*  <i
                                      className='fa fa-cart-plus me-2'
                                      aria-hidden='true'></i>
                                    <p className='m-0'>{pakagesdetail.description}</p> */}
                                    </div>
                                  </div>

                                  {/* Price area */}
                                  <div>
                                    <h6>${pakagesdetail.price}</h6>
                                  </div>
                                </div>
                              </div>

                            ))}


                            {itemdetails.map((itemdetail, index2) => (
                              <div className='col-md-12 pointer' onClick={(e) => pakageset(e, index, itemdetail)}>
                                <div className='d-flex justify-content-between mt-3'>
                                  <div className='single_item'>
                                    <h5>{itemdetail.name}</h5>

                                    <div className='d-flex align-items-center mt-2 cart_item'>
                                      {/* <i
                                              className='fa fa-cart-plus me-2'
                                              aria-hidden='true'></i>
                                            <p className='m-0'>{itemdetail.description}</p>  */}
                                    </div>
                                  </div>

                                  {/* Price area */}
                                  <div>
                                    <h6>$ {itemdetail.price}</h6>
                                  </div>
                                </div>
                              </div>
                            ))}


                            {/* single item */}

                          </div>
                        </div>
                      </div>
                      <div
                        className='tab-pane fade'
                        id='pills-profile'
                        role='tabpanel'
                        aria-labelledby='pills-profile-tab'
                        tabIndex='0'>
                        <div className='tab_box_item px-3 py-3'>
                          <div className='row'>
                            {/* single item */}

                            {pakagesdetails.map((pakagesdetail, index2) => (
                              <div className='col-md-12 pointer' onClick={(e) => pakageset(e, index, pakagesdetail)} >
                                <div className='d-flex justify-content-between mt-3'>
                                  <div className='single_item'>
                                    <h5>
                                      {pakagesdetail.name}
                                    </h5>

                                    <div className='d-flex align-items-center mt-2 cart_item'>
                                      {/*        <i
                                                                                className='fa fa-cart-plus me-2'
                                                                                aria-hidden='true'></i>
                                                                              <p className='m-0'>{pakagesdetail.description}</p>

                                                                              */}
                                    </div>
                                  </div>

                                  {/* Price area */}
                                  <div>
                                    <h6>${pakagesdetail.price}</h6>
                                  </div>
                                </div>
                              </div>

                            ))}

                            {/* single item */}
                            {/*
                            <div className='col-md-12 mt-3'>
                              <div className='d-flex justify-content-between mt-3'>
                                <div className='single_item'>
                                  <h5>
                                    Firefly Photo Booth <br /> 2 Hour Rental
                                  </h5>

                                  <div className='d-flex align-items-center mt-2 cart_item'>
                                    <i
                                      className='fa fa-cart-plus me-2'
                                      aria-hidden='true'></i>
                                    <p className='m-0'>package template</p>
                                  </div>
                                </div>   */}

                            {/* Price area */}
                            {/* <div>
                                  <h6>$400</h6>
                                </div>
                              </div>
                            </div> */}





                          </div>
                        </div>
                      </div>
                      <div
                        className='tab-pane fade'
                        id='pills-contact'
                        role='tabpanel'
                        aria-labelledby='pills-contact-tab'
                        tabIndex='0'>
                        <div className='tab_box_item px-3 py-3'>
                          <div className='row'>
                            {/* single item */}

                            {itemdetails.map((itemdetail, index2) => (
                              <div className='col-md-12 pointer' onClick={(e) => pakageset(e, index, itemdetail)}>
                                <div className='d-flex justify-content-between mt-3'>
                                  <div className='single_item'>
                                    <h5>{itemdetail.name}</h5>

                                    <div className='d-flex align-items-center mt-2 cart_item'>
                                      {/* <i
                                              className='fa fa-cart-plus me-2'
                                              aria-hidden='true'></i>
                                            <p className='m-0'>{itemdetail.description}</p>  */}
                                    </div>
                                  </div>

                                  {/* Price area */}
                                  <div>
                                    <h6>$ {itemdetail.price}</h6>
                                  </div>
                                </div>
                              </div>
                            ))}

                            {/* single item */}

                            {/* single item */}

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className='service_item d-flex align-items-center'>
                {/* QYT field */}
                <span className='me-2 qyt'>
                  <span className="pricespan">*</span>
                  <input type='number' placeholder='QYT' value={service.qty} onChange={(e) => changeqty(e, index)} />
                </span>

                {/* UNIT Field */}
                <span className='position-relative'>
                  <span className="pricespan">*</span>
                  <UnitOption onChange={handleSelectedValueChange} indexval={index} rawselectedOption={service.unit_option} />
                </span>
              </div>
              <div className='service_item d-flex align-items-center'>
                <div className='form-check '>
                  { /* <input
                                className='form-check-input'
                                type='checkbox'
                                name='tax'
                                value=''
                                id='flexCheckDefault'
                                checked={service.tax ? 'checked' : ''}
                              /> */}
                </div>
                <div className='form-check qyt'>
                  <span className="pricespan">*</span>
                  <input type='number' placeholder='Price' value={service.price} onChange={(e) => changeprice(e, index)} />
                  <small></small>

                </div>
              </div>

              {/* Delete button */}
              <div className='position-absolute delete_btn'>
                <button onClick={() => deleteService(index)}>
                  <i className='fas fa-trash-alt'></i>
                </button>
              </div>

              <div className="textare2">
                <span className="markred">*</span>

                <textarea ref={el => ref2.current[index] = el} placeholder='Enter a description' rows={1} onInput={(e) => handleInput(e, index)} name={index} id={`desc-${index}`} className="textare"
                  onChange={(e) => changedesc(e, index)}
                  value={service.descp}
                />
                <small></small>
              </div>

            </div>
          ))}

          {/* add new item button  */}
          <div className='create_new_service py-5'>
            <button onClick={addNewService}>+ Add item / package</button>
          </div>

          {/* Summary*/}
          <div className='card-body'>
            <div className='row flex-column-reverse flex-md-row row-gap-4 row-gap-md-0'>
              <div className='col-md-5 d-flex align-items-end'></div>

              <div className='col-md-7 ml-auto'>
                <table className='table create_invoice_table table-clear'>
                  <tbody>
                    <tr>
                      <td className='left'>
                        <span>Subtotal</span>
                      </td>
                      <td className='right'>${(Number(subtotalprice) || 0).toFixed(2)}</td>
                    </tr>
                    {/* Tax box */}
                    <tr>
                      <td className='left position-relative'>
                        <span className='pointer' onClick={toggleTaxBox}>
                          Tax {/* <span>8.5%</span> */}
                        </span>
                        {showTaxBox && (
                          <div className='edit_discount_box edit_tax_box position-relative'>
                            <div className='box_header d-flex align-items-center justify-content-between mb-2'>
                              <h5>Edit Tax</h5>
                              <span onClick={() => setShowTaxBox(false)}>
                                <i className='fas fa-close'></i>
                              </span>
                            </div>
                            <div className='box-content mt-2 d-flex align-items-center'>
                              <input
                                type='number'
                                className='me-2'
                                placeholder='Tax'
                                value={tax}
                                onChange={(e) => settax(e.target.value)}
                              />


                              <div className='input-group'>
                                <span className={`input-group-text ${taxper ? 'taxgreen' : ''}`}

                                  id='basic-addon1' onClick={() => settaxper(true)}>
                                  %
                                </span>
                                <span className={`input-group-text ${taxper ? '' : 'taxgreen'}`}

                                  id='basic-addon1' onClick={() => settaxper(false)}>
                                  $
                                </span>
                              </div>

                              {/* delete button */}
                              <div>
                                {" "}
                                <i className='fas fa-trash text-danger' onClick={() => settax(0)}></i>
                              </div>
                            </div>

                            <div className='discount_arrow'></div>
                          </div>
                        )}
                      </td>
                      <td className='right'>${(Number(taxval) || 0).toFixed(2)}</td>
                    </tr>

                    {/* add discount box */}
                    <tr>
                      <td className='left position-relative'>
                        {showDiscountBox ? (
                          <span className='pointer'>Discount</span>
                        ) : (
                          <span className='pointer' onClick={toggleDiscountBox}>
                            + Add Discount
                          </span>
                        )}

                        {/* edit discount box */}
                        {showDiscountBox && (
                          <div className='edit_discount_box position-relative'>
                            <div className='box_header d-flex align-items-center justify-content-between mb-2'>
                              <h5>Edit Discount</h5>
                              <span onClick={() => setShowDiscountBox(false)}>
                                <i className='fas fa-close'></i>
                              </span>
                            </div>
                            <div className='box-content mt-2 d-flex align-items-center'>
                              <input type='number' className='me-2' value={discount} onChange={(e) => setdiscount(e.target.value)} />

                              <div className='input-group'>
                                <span className={`input-group-text ${discountper ? 'taxgreen' : ''}`}

                                  id='basic-addon1' onClick={() => setdiscountper(true)}>
                                  %
                                </span>
                                <span className={`input-group-text ${discountper ? '' : 'taxgreen'}`}
                                  id='basic-addon1' onClick={() => setdiscountper(false)}>
                                  $
                                </span>
                              </div>

                              {/* delete button */}
                              <div>
                                {" "}
                                <i className='fas fa-trash text-danger' onClick={() => setdiscount(0)} ></i>
                              </div>
                            </div>

                            <div className='discount_arrow'></div>
                          </div>
                        )}
                      </td>
                      <td className='right'>
                        <strong>${(Number(discountval) || 0).toFixed(2)}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className='left'>
                        <span>Total USD</span>
                      </td>
                      <td className='right'>
                        <strong>{(Number(totalprice) || 0).toFixed(2)}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* PAYMENT SCHEDULE */}
      <section className='section_container my-4 px-2 px-md-5 py-5'>
        <div className='title'>
          <h4>PAYMENT SCHEDULE</h4>
        </div>
        {/* <div className='table-responsive mt-5'>
          {" "}
          <table className='table invoice_table'>
            <thead>
              <tr>
                <th scope='col'>AMOUNT</th>
                <th scope='col'>DUE DATE</th>
                <th scope='col'>PAYMENT DATE</th>
                <th scope='col'>PAYMENT ID</th>
                <th scope='col'>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => (
                <tr key={index}>
                  <th scope='row ' className='hover_payment'>
                    <span>${(Number(payment.amount) || 0).toFixed(2)}</span>
                  </th>
                  <td
                    className='due_date hover_payment'
                    style={{ zIndex: 9999, position: "relative" }}>
                    <span
                      style={{ fontSize: "16px" }}
                      onClick={() => toggleDueDateBox(index)}>
                      {payment.dueDate}
                    </span>
                    Due date box
                  </td>
                  <td>-</td>
                  <td>-</td>
                  Delete payment
                  <td
                    className='text-center position-relative'
                    style={{ cursor: "pointer" }}>
                    <i
                      className='fas fa-trash text-danger'
                      onClick={() => deletePayment(index)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div> */}
        <div className='payment_schedule_container mt-2'>
          <table>
            <thead>
              <tr>
                <th scope='col' style={{ width: "74px" }}>
                  AMOUNT
                </th>
                <th scope='col'>DUE DATE</th>
                <th scope='col'>PAYMENT DATE</th>
                <th scope='col'>PAYMENT ID</th>
                <th scope='col' style={{ width: "74px" }}>
                  STATUS
                </th>
              </tr>
            </thead>
            <tbody>

              {payments.map((data, i) => (
                <tr key={i}>
                  <td data-label='Amount' className='due_date hover_payment position-relative'>
                    {payments.length === 1 ? (
                      <span className='hover_item' title='Single payment equals total'>
                        ${(Number(data.amount) || 0).toFixed(2)}
                      </span>
                    ) : (
                      <span className='hover_item' onClick={() => togglecustompaymentBox(i, data.amount)}>
                        ${(Number(data.amount) || 0).toFixed(2)}
                        {custompaymentbox === i && (
                          <div className='due_date_box' onClick={handlePropagation}>
                            <div className='due_date_box_header align-items-center justify-content-between' style={{ textAlign: 'left' }}>
                              <h4>Set Payment Amount</h4>
                              <div style={{ clear: 'both', justifyContent: 'space-around', display: 'flex' }}>
                                <button onClick={() => setshowcustombox((prev) => !prev)}>Custom</button>
                                <button
                                  onClick={() => setamounttype((prev) => !prev)}
                                  style={{
                                    backgroundColor: amounttype ? 'green' : 'gray',
                                    color: 'white',
                                    padding: '10px 20px',
                                    border: 'none',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                  }}>
                                  Equal Payments
                                </button>
                              </div>
                              {showcustombox && (
                                <div>
                                  <br />
                                  <input type='text' value={customprice} onChange={(e) => setcustomprice(e.target.value)} />
                                </div>
                              )}
                              <div className='mt-3 text-end'>
                                <button onClick={() => savepaymenttogle(i)}>Save</button>
                              </div>
                            </div>
                            <div className='arrow'></div>
                          </div>
                        )}
                      </span>
                    )}
                  </td>
                  <td
                    data-label='DUE DATE'
                    className='due_date hover_payment position-relative'>
                    <span
                      className='hover_item'
                      onClick={() => toggleDueDateBox(i)}>
                      {data.dueDate}

                      {showDueDateBox === i && (
                        <div
                          className='due_date_box'
                          onClick={handlePropagation}>
                          <div className='due_date_box_header d-flex align-items-center justify-content-between'>
                            <h4>Set Payment Due</h4>
                            <span onClick={() => toggleDueDateBox(i)}>
                              <i className='fas fa-close'></i>
                            </span>
                          </div>
                          <div className='arrow'></div>

                          <div className='due_date_box_content mt-2'>
                            {smartdate && (
                              <CommonDropdownMenuThree options={options} suboption={options_sub} handleOptionSelect={handleOptionSelect} rawselectedOption={options[1]} />
                            )
                            }

                            {!smartdate && (
                              <CommonDropdownMenuThree options={options} suboption={options_sub} handleOptionSelect={handleOptionSelect} rawselectedOption={options[0]} />
                            )
                            }

                            {
                              smartdate && (
                                <div className="d-flex smartdate">
                                  <input className="smardatinp" value={smartday} onChange={(e) => setsmartday(e.target.value)} />&nbsp;
                                  <CommonDropdownMenufour options={options2} handleOptionSelect={handleOptionSelectsmartmonth} rawselectedOption={options2[0]} />&nbsp;
                                  <CommonDropdownMenufour options={options3} handleOptionSelect={handleOptionSelectsmartyear} rawselectedOption={options3[0]} />
                                </div>
                              )

                            }


                            {!smartdate && (
                              <div className='mt-3 date_input'>
                                <input
                                  type='date'
                                  onChange={(event) => handleDateChange(event, i)}
                                  value={payments?.dueDate}
                                />
                              </div>
                            )

                            }



                            <div className='mt-3 text-end'>
                              <button onClick={() => toggleDueDateBox(i)}>
                                Save
                              </button>
                            </div>
                          </div>

                          <div className='arrow'></div>
                        </div>
                      )}
                    </span>
                  </td>
                  <td data-label='PAYMENT DATE'>-</td>
                  <td data-label='PAYMENT ID'>-</td>
                  <td
                    data-label='STATUS'
                    className='text-end position-relative'
                    style={{ cursor: "pointer" }}>
                    <i
                      className='fas fa-trash text-danger'
                      onClick={() => deletePayment(i)}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* add new payment button  */}
        <div className='add-new-payment py-5'>
          <button onClick={addNewPayment}>+ Add Another Payment</button>
        </div>
      </section>
      {/* hidden div for style */}
      <div className=' my-2 px-5 py-2 invisible'></div>
    </>
  );
});

export default React.memo(CreateInvoiceContent);
